module.exports = "/_next/static/images/label_active-d1e23bdb3289f7c94ca4097ced774c41.svg";